import { 
    GET_DADOS_USUARIO,
    LIMPAR_DADOS_USUARIO,
    USUARIO_NOTIFICACOES_MARCAR_LIDA,
    USUARIO_NOTIFICACOES_MARCAR_NAO_LIDA,
} from '../actions';

export default function usuarioReducer(state = null, action){

    switch(action.type){
        case GET_DADOS_USUARIO:
            return action.data;
        case LIMPAR_DADOS_USUARIO: // Quando o usuario faz logout
            return null;
        case USUARIO_NOTIFICACOES_MARCAR_LIDA: // Quando uma notificacao é lida
            return {
                ...state,
                notificacoes: state.notificacoes.filter(ele=> String(ele.id_notificacao) !== String(action.data.id_notificacao) ),
            }
        case USUARIO_NOTIFICACOES_MARCAR_NAO_LIDA: // Quando uma notificacao e marcada como nao lida
            return {
                ...state,
                notificacoes: state.notificacoes.concat(action.data),
            }
        default:
            return state;
    }
}
